import { Box, Grid, Stack, Text } from '@stitch-fix/mode-react';

export const LandingInfoModule = (props: {
  id: string;
  name: string;
  content: { description: string; headline: string }[];
  headline: string;
  isMobile: boolean;
}) => {
  const { content, headline, isMobile } = props;

  const ContainerComponent = isMobile ? Stack : Grid;
  const containerProps = isMobile
    ? { spacing: 1.5 }
    : { spacing: 3, columns: 3 };

  return (
    <Box
      px={{
        sm: 1,
        md: 3,
        lg: 5,
        xl: 7,
        xxl: 9,
      }}
      py={2}
    >
      <Text setting="title-large" align="center" color="blue-45" mb={1.5}>
        {headline}
      </Text>
      <ContainerComponent {...containerProps}>
        {content.map(item => {
          return (
            <Box key={item.headline}>
              <Text
                setting="title-medium"
                align="center"
                color="blue-45"
                mb={0.5}
              >
                {item.headline}
              </Text>
              <Text setting="body-large" align="center" color="blue-45">
                {item.description}
              </Text>
            </Box>
          );
        })}
      </ContainerComponent>
    </Box>
  );
};
